import { faPlug } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function offline() {
    return (
        <div data-cy="history-offline">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.offline" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faPlug} style={{ color: 'red' }} size="lg" />
            </Whisper>
        </div>
    );
}
